module.exports = __webpack_public_path__ + "static/hyperv_46.fd0c9c74.png";